import React, { useState, useRef, useEffect } from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import '../assests/css/Booking.css'
import { Checkbox, Radio } from '@mui/material';
import { red } from '@mui/material/colors';
import { Link } from 'react-router-dom';

const Booking = () => {
    const ref1 = useRef();
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const [selectedValue, setSelectedValue] = React.useState('booking_online');
    const [selectedValue1, setSelectedValue1] = React.useState('credit_card');
    const [state, setState] = useState({
        fullname: "",
        phone: "",
        pickup_date: "",
        pickup_time: "",
        pickup_address: "",
        dropoff_address: "",
        no_of_passengers: "",
        flight_no: "",
        no_of_luggae: "",
        large_selected_car: "",
        small_selected_car: "",
        driver_note: "",
    });

    const [bigvehicle, setBigVehicle] = useState(true);

    const [terms_check, setTermsChecked] = useState(false);

    const InputVal = (e) => {

        let { name, value } = e.target;
        setState({ ...state, [name]: value });

    }

    useEffect(() => {
        if (state.no_of_passengers >= 5) {
            setBigVehicle(true);
            setState({ ...state, large_selected_car: null });
        } else {
            setBigVehicle(false);
            setState({ ...state, small_selected_car: null });
        }
    }, [state.no_of_passengers]);

    console.log('from booking page herer', state)

    // terms and condition checking
    const CheckBox = (e) => {
        setTermsChecked(e.target.checked);
    }

    const handleChange = (event) => {
        // booking online or flight radio
        setSelectedValue(event.target.value);
    };

    const handleChange1 = (event) => {
        // payment type credit card or cash
        setSelectedValue1(event.target.value);
    };


    return (
        <div className='booking'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12  my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Booking</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='policies pt-5 pb-5'>
                <div className='container '>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <form>
                                <p className='f-25 px-0 f-pop-med'>Booking Details</p>
                                <div className='d-flex p-0 mt-4'>
                                    <Radio
                                        checked={selectedValue === 'booking_online'}
                                        onChange={handleChange}
                                        value="booking_online"
                                        name="radio-buttons"
                                        inputProps={{ 'aria-label': 'booking_online' }}

                                        sx={{
                                            color: red[800],
                                            '&.Mui-checked': {
                                                color: red[800],
                                            },
                                        }}
                                    />
                                    <p className='red_booking mt-2 f-pop-semibold f-15 mt-res-booking-768'>Booking Online</p>
                                    <div className='border-right-lightgry ms-3 me-2'>

                                    </div>
                                    <Radio
                                        checked={selectedValue === 'booking_flight'}
                                        onChange={handleChange}
                                        value="booking_flight"
                                        name="radio-buttons"
                                        inputProps={{ 'aria-label': 'booking_flight' }}
                                        sx={{
                                            color: red[800],
                                            '&.Mui-checked': {
                                                color: red[800],
                                            },
                                        }}
                                    />
                                    <p className='mt-2 f-pop-semibold f-15 mt-res-booking-768'>Flight</p>
                                </div>
                                <div className='crd-cstm-booking'>
                                    <p className='f-25 mb-1 f-pop-med'>Passenger Details</p>

                                    {(selectedValue === "booking_online") ?
                                        <div className='row'>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.fullname || ""}
                                                    name="fullname"
                                                    type='text' className='form-control p-3 f-14 bg-input-booking f-pop-med' placeholder='Full Name' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.phone || ""}
                                                    name="phone"
                                                    type='text' className='form-control p-3 f-14 bg-input-booking f-pop-med' placeholder='Phone Number' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input placeholder="Pick up date" type='date'
                                                    onChange={InputVal}
                                                    value={state.pickup_date || ""}
                                                    name="pickup_date"
                                                    // ref={ref}
                                                    // onFocus={() => (ref.current.type = "date")}
                                                    // onBlur={() => (ref.current.type = "text")}
                                                    className='form-control p-3 f-14 bg-input-booking f-pop-med' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input type='text'
                                                    onChange={InputVal}
                                                    value={state.pickup_time || ""}
                                                    name="pickup_time"
                                                    placeholder='pick up Time'
                                                    ref={ref1}
                                                    onFocus={() => (ref1.current.type = "time")}
                                                    onBlur={() => (ref1.current.type = "text")}
                                                    className='form-control p-3 f-14 bg-input-booking f-pop-med' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.pickup_address || ""}
                                                    name="pickup_address"
                                                    type='text' className='form-control p-3 f-14 bg-input-booking f-pop-med' placeholder='Pick up Address' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.dropoff_address || ""}
                                                    name="dropoff_address"
                                                    type='text' className='form-control p-3 f-14 bg-input-booking f-pop-med' placeholder='Drop Off Address' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.no_of_passengers || ""}
                                                    name="no_of_passengers"
                                                    type='text' className='form-control p-3 f-14 bg-input-booking f-pop-med' placeholder='No. of Passengers' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.flight_no || ""}
                                                    name="flight_no"
                                                    type='text' className='form-control p-3 f-14 bg-input-light border-0 f-pop-med' placeholder='Flight number (BA1386) or Airports (LHR - MAN) or City (London)' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                <input
                                                    onChange={InputVal}
                                                    value={state.no_of_luggae || ""}
                                                    name="no_of_luggae"
                                                    type='text' className='form-control p-3 f-14 bg-input-booking f-pop-med' placeholder='No. of Luggage' />
                                            </div>
                                            <div className='col-lg-6 mt-3'>
                                                {(bigvehicle) ? <select
                                                    onChange={InputVal}
                                                    value={state.large_selected_car || ""}
                                                    name="large_selected_car"
                                                    className='form-control form-select p-3 f-14 bg-input-booking f-pop-med'>
                                                    <option value=" " className='f-pop-med f-14'>
                                                        Select Vehicle
                                                    </option>
                                                    <option value="Mercedes Vito" className='f-pop-med f-14'>
                                                        Mercedes Vito
                                                    </option>
                                                    <option value="Ford Galaxy" className='f-pop-med f-14'>
                                                        Ford Galaxy
                                                    </option>
                                                </select> : <select
                                                    onChange={InputVal}
                                                    value={state.small_selected_car || ""}
                                                    name="small_selected_car"
                                                    className='form-control form-select p-3 f-14 bg-input-booking f-pop-med'>
                                                    <option value="" className='f-pop-med f-14'>
                                                        Select Vehicle
                                                    </option>
                                                    <option value="Mercedes C class" className='f-pop-med f-14'>
                                                        Mercedes C class
                                                    </option>
                                                    <option value="Sokda Superb State" className='f-pop-med f-14'>
                                                        Sokda Superb State
                                                    </option>
                                                </select>}

                                            </div>
                                            <div className='col-lg-12 mt-3'>
                                                <textarea
                                                    onChange={InputVal}
                                                    value={state.driver_note || ""}
                                                    name="driver_note"
                                                    row={5} className='form-control p-3 f-14 bg-input-booking no-resize f-pop-med' placeholder='Driver Note'></textarea>
                                            </div>
                                        </div> : 
                                        <div className='row'>

                                            
                                        </div>
                                        }


                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <p className='f-15 px-0 f-pop-med mt-4 '>Payment Type</p>
                                            <div className='d-flex p-0 mt-2'>
                                                <Radio
                                                    checked={selectedValue1 === 'credit_card'}
                                                    onChange={handleChange1}
                                                    value="credit_card"
                                                    name="radio-buttons"
                                                    inputProps={{ 'aria-label': 'credit_card' }}

                                                    sx={{
                                                        color: red[800],
                                                        '&.Mui-checked': {
                                                            color: red[800],
                                                        },
                                                    }}
                                                />
                                                <p className='red_booking mt-2 f-pop-med f-15 mt-res-booking-768'>Credit Card</p>
                                                <div className='border-right-lightgry ms-3 me-2'>

                                                </div>
                                                <Radio
                                                    checked={selectedValue1 === 'cash'}
                                                    onChange={handleChange1}
                                                    value="cash"
                                                    name="radio-buttons"
                                                    inputProps={{ 'aria-label': 'cash' }}
                                                    sx={{
                                                        color: red[800],
                                                        '&.Mui-checked': {
                                                            color: red[800],
                                                        },
                                                    }}
                                                />
                                                <p className='mt-2 f-pop-med f-15 mt-res-booking-768'>Cash</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-9  mb-4 mt-3 align-self-center '>
                                            <input
                                                onChange={CheckBox}
                                                value={terms_check}
                                                type='checkbox' className='me-3' />
                                            <span className='clr-43'>
                                                Terms and conditions Easily generate and manage a Terms and Conditions document that is profession
                                            </span>
                                        </div>
                                        <div className='col-lg-3 mb-4 mt-3  text-end'>
                                            <Link to="/payment" className='link_ourfleet'>
                                                <button className="btn btn-danger red-clr-btn p-bt-cus f-14 f-pop-med">Proceed</button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        {/* <div className='row mb-4 mt-3'>
                           
                        </div> */}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Booking;